export default __webpack_public_path__ + "static/CanRefugee Logo (Stacked)-fab737189f2634c37f6a5caeb2aef08f.jpg";